<template>
  <div class="publicSuccess">
    <div class="safe">
      <div class="successBox">
        <div class="title">
          购买成功
        </div>
        <div class="mainCon">
          <div class="card">
            <div class="name">
              中国体育超级会员·{{cardInfo.cardType == '1' ? '月卡' : '年卡'}}
            </div>
            <div class="info">
              <div class="icon">
                <img :src="info.userHeadImg" alt="">
              </div>
              <div class="rightInfo">
                <div class="count">
                  {{info.userName}}
                </div>
                <div class="status">
                  {{conductDate(info.vipExpiryTime)}} 到期
                </div>
              </div>
            </div>
          </div>
          <div class="card card2">
            <div class="name">
              央视体育VIP·{{cardInfo.cardType == '1' ? '月卡' : '年卡'}}
            </div>
            <div class="info">
              <div class="icon">
                <img src="https://images.zhibo.tv/2021/0601/cctv_logo.png" alt="">
              </div>
              <div class="rightInfo">
                <div class="count">
                  {{conductMobile(info.userMobile)}}
                </div>
                <div class="status">
                  请于{{conductDate(info.cctvVipExpiryTime)}}前激活
                </div>
              </div>
            </div>
          </div>
          <div class="desc">
            激活方法：下载央视体育VIP App后，使用手机号：{{conductMobile(info.userMobile)}}登录即可激活央视体育VIP会员
          </div>
          <div class="btn" @click="doClose">
            我知道了
          </div>
        </div>
        <!-- 关闭按钮 -->
        <div class="icon_close" @click="doClose">
          <img src="https://images.zhibo.tv/2021/0521/icon_cancel@3x.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    token: {
      type: String,
      default: ''
    },
    vipId: {
      type: String,
      default: ''
    },
    cardInfo: {
      type: Object,
      default: () => {}
    }
  },
  name: '',
  data () {
    return {
      info: {}
    };
  },
  computed: {
  },
  created () { 
    this.getPaySuccesInfo()
  },
  methods: {
    // 关闭
    doClose () {
      window.location.reload()
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('changeSuccessDialogShow', false);
    },
    // 获取支付成功信息
    async getPaySuccesInfo() {
      let params = {
        token: this.token,
        vipId: this.vipid
      }
      const { data } = await this.$api.getVipPaySuccseInfo(params)
      this.info = data.data
      console.log(this.info, '1111')
    },
    // 处理日期格式
    conductDate(val) {
      return val && val.length > 10 ? val.slice(0, 10) : val
    },
    // 处理手机格式
    conductMobile(val) {
      let reg = /1(\d{2})\d{4}(\d{4})/g;
      return val && val.length > 0 ? val.replace(reg, "1$1****$2") : val
    }
  }
}
</script>

<style lang='less' scoped>
.publicSuccess {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  .safe {
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  }
  .successBox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    width: 5.6rem;
    height: 8.54rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    .title {
      width: 100%;
      box-sizing: border-box;
      padding: 0.4rem 0 0.32rem 0;
      border-bottom: 0.14vw solid #e5e5e5;
      font-size: 0.34rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222222;
      text-align: center;
      line-height: 0.48rem;
    }
    .mainCon {
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem 0.4rem 0.4rem 0.4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .card {
        width: 100%;
        margin-bottom: 0.4rem;
        .name {
          margin-bottom: 0.12rem;
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 0.4rem;
        }
        .info {
          width: 100%;
          background: #f7f7f7;
          border-radius: 0.12rem;
          box-sizing: border-box;
          padding: 0.12rem;
          display: flex;
          .icon {
            width: .84rem;
            height: .84rem;
            background: linear-gradient(152deg, #3D3D3F 0%, #303032 100%);
            box-shadow: 0px 1px 6px 2px rgba(0, 0, 0, 0.06);
            border-radius: 100%;
            overflow: hidden;
            margin: .08rem;
            img {
              display: block;
              width: .84rem;
              height: .84rem;
              object-fit: contain;
            }
          }
          .rightInfo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin: 0.12rem 0 0.12rem 0.12rem;
            .count {
              font-size: 0.24rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 0.32rem;
            }
            .status {
              font-size: 0.24rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 0.32rem;
              margin-top: .12rem;
            }
          }
        }
      }
      .card2 .icon {
        background: #3a3a3c!important;
        display: flex;
        justify-content: center;
        align-content: center;
        img {
          width: .58rem!important;
        }
      }
      // 描述
      .desc {
        margin-bottom: 0.48rem;
        text-align: center;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.36rem;
      }
      // 我知道了按钮
      .btn {
        width: 3.2rem;
        height: 0.8rem;
        background: url('../assets/icon/btn2@2x.png') no-repeat center;
        background-size: 100%;
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #984b26;
        text-align: center;
        line-height: 0.8rem;
      }
    }
    // 关闭按钮
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      right: 0.24rem;
      top: 0.24rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}
</style>
